import React from "react";
import { Form, Input, InputNumber, Select } from "antd";
import { useTranslation } from "react-i18next";

import QuestionBase from "~/modules/SurveysTemplates/SurveyForm/questions/QuestionBase";

const ScaleQuestion = () => {
  const { t } = useTranslation("surveys");
  const form = Form.useFormInstance();

  const handleVariantChange = (variant: "nps" | "rating") => {
    const question = form.getFieldValue("question");
    form.setFieldsValue({
      question: {
        ...question,
        variant,
        min: variant === "nps" ? 0 : 1,
        max: variant === "nps" ? 10 : 5,
        step: 1,
      },
    });
  };

  return (
    <div>
      <QuestionBase />

      <Form.Item name={["question", "variant"]} label={t("questionForm.scaleVariant")}>
        <Select
          onChange={handleVariantChange}
          options={[
            { value: "nps", label: t("questionForm.scaleVariantNps") },
            { value: "rating", label: t("questionForm.scaleVariantRating") },
          ]}
        />
      </Form.Item>

      <Form.Item
        name={["question", "min"]}
        label={t("questionForm.scaleMin")}
        rules={[{ required: true, message: t<string>("common:validationErrors.fieldIsRequired") }]}
      >
        <InputNumber min={0} max={100} precision={0} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        name={["question", "max"]}
        label={t("questionForm.scaleMax")}
        dependencies={[["question", "min"]]}
        rules={[
          { required: true, message: t<string>("common:validationErrors.fieldIsRequired") },
          ({ getFieldValue }) => ({
            validator(_, value) {
              const min = getFieldValue(["question", "min"]);
              if (typeof min !== "number" || typeof value !== "number" || value > min) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t("questionForm.scaleMaxValidation")));
            },
          }),
        ]}
      >
        <InputNumber min={1} max={100} precision={0} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        name={["question", "step"]}
        label={t("questionForm.scaleStep")}
        rules={[{ required: true, message: t<string>("common:validationErrors.fieldIsRequired") }]}
      >
        <InputNumber min={1} max={10} precision={0} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item name={["question", "minLabel"]} label={t("questionForm.scaleMinLabel")}>
        <Input />
      </Form.Item>

      <Form.Item name={["question", "maxLabel"]} label={t("questionForm.scaleMaxLabel")}>
        <Input />
      </Form.Item>
    </div>
  );
};

export default ScaleQuestion;
